export default "<p>auth works!</p>\n"